import api from './api';

export const clientsAPI = {
  list: (params) => api.get('/api/clients', { params }),
  create: (data) => api.post('/api/clients', data),
  get: (id) => api.get(`/api/clients/${id}`),
  update: (id, data) => api.patch(`/api/clients/${id}`, data),
  remove: (id) => api.delete(`/api/clients/${id}`),
  updateOnboarding: (id, data) => api.patch(`/api/clients/${id}/onboarding`, data),
  
  // People
  listPeople: (clientId) => api.get(`/api/clients/${clientId}/people`),
  addPerson: (clientId, data) => api.post(`/api/clients/${clientId}/people`, data),
};
